<div class="skip-links">
  @for (link of skipLinks; track link.id) {
    <button class="skip-link-container" (focus)="onFocus()" (blur)="onBlur()" (click)="skipToLandmark($event, link.id)">
      <div class="skip-link">
        <span>{{ link.label }}</span>
        <svg-icon src="assets/images/icons/chevron_right.svg" class="icon-right"></svg-icon>
      </div>
    </button>
  }
</div>
